import React, { useEffect } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { get } from "lodash"
import io from "socket.io-client"
import { ToastContainer, toast } from "react-toastify"
import { SingleNotification } from "../pages/notifications/components/_NotificationsList"
import CancelIcon from "../imgs/cancel.svg"
import camelize from "../utils/camelize"

const BottomLeftNotificationWrapper = styled.div`
  .notification-toast-container {
    width: 402px;
    .Toastify__toast {
      border: 1px solid #f1f1f1;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04),
        0px 8px 16px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
    }
  }
`

const SingleNotificationToast = styled.div`
  padding: 16px;
  padding-bottom: 4px;
  font-family: "Lato";
  font-style: normal;
  .notification-wrapper-link {
    text-decoration: none;
  }
  .notification-content {
    padding-right: 10px;
  }
`

const ActionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 12px;
`
const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;

  color: #0e1616;
`
const ActionButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  .button-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #667af4;
    margin-left: 5px;
  }
`

const RealTimeNotification = ({ authStore, notificationStore }) => {
  useEffect(() => {
    return () => {
      if (!notificationStore.state.socket) return
      notificationStore.state.socket.disconnect()
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      if (notificationStore && authStore) {
        await authStore.state
        const userID = get(authStore, "state.user.id")
        if (userID && !notificationStore.state.hasLoaded) {
          notificationStore.fetchNotifications(1, 5)
        }
        if (userID) {
          notificationStore.setState({
            socket: io.connect(process.env.RP_SOCKET_URL, {
              query: `userID=${userID}`,
            }),
          })
        }
      }
    })()
  }, [authStore, notificationStore])

  useEffect(() => {
    if (!notificationStore.state.socket) return
    notificationStore.state.socket.removeAllListeners()
    notificationStore.state.socket.on("notification", data => {
      const newNotification = camelize(data)
      toast(<Msg notification={newNotification} />, {
        containerId: "notification",
      })
      const finalNotifications = [
        { ...newNotification },
        ...notificationStore.state.notifications,
      ]
      notificationStore.setState({
        notifications: finalNotifications,
        hasUnread: true,
      })
    })
  }, [notificationStore.state.socket])

  const Msg = ({ closeToast, notification }) => (
    <SingleNotificationToast>
      <ActionHeader>
        <Title>NEW NOTIFICATION</Title>
        <ActionButton onClick={closeToast}>
          <img className="button-img" src={CancelIcon} alt="cancel-img" />
        </ActionButton>
      </ActionHeader>
      <Link to={"/notifications"} className="notification-wrapper-link">
        <SingleNotification
          notification={notification}
          isPopUp={true}
          showRighIcon={true}
          isRealTime={true}
        />
      </Link>
    </SingleNotificationToast>
  )

  return (
    <BottomLeftNotificationWrapper>
      <ToastContainer
        className="notification-toast-container"
        autoClose={false}
        closeButton={false}
        position="bottom-left"
        enableMultiContainer
        containerId={"notification"}
      />
    </BottomLeftNotificationWrapper>
  )
}

export default RealTimeNotification
